import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { AMAZON_URL } from "./constants";

export const BuyButton = ({
  label = "Buy Now on Amazon",
  testId,
  dark = false,
  className = "",
}) => (
  <motion.a
    data-testid={testId}
    href={AMAZON_URL}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Buy the Love the Life You Live gratitude journal on Amazon (opens in a new tab)"
    whileHover={{ scale: 1.03, y: -2 }}
    whileTap={{ scale: 0.98 }}
    transition={{ type: "spring", stiffness: 320, damping: 22 }}
    className={`shine-btn group inline-flex items-center gap-2.5 rounded-full px-7 py-3.5 text-sm font-sans font-semibold tracking-wide transition-shadow duration-300 ${
      dark
        ? "bg-linen text-espresso hover:shadow-[0_16px_40px_-10px_rgba(251,248,243,0.4)]"
        : "bg-terracotta text-paper hover:bg-siennadeep hover:shadow-[0_18px_44px_-12px_rgba(168,77,53,0.55)]"
    } ${className}`}
  >
    {label}
    <ArrowUpRight
      size={17}
      className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
    />
  </motion.a>
);
